import React from "react";

import CommonSection from "../components/UI/CommonSection";
import Helmet from "../components/Helmet/Helmet";
import AboutSection from "../components/UI/AboutSection";
import { Container, Row, Col } from "reactstrap";

import driveImg from "../assets/all-images/drive.jpg";
import "../styles/about.css";

const About = () => {
  return (
    <Helmet title="O nas">
      <CommonSection title="O nas" />
      <AboutSection aboutClass="aboutPage" />

      <section className="about__page-section">
        <Container>
          <Row>
            <Col lg="6" md="6" sm="12">
              <div className="about__page-img">
                <img src={driveImg} alt="" className="w-100 rounded-3" />
              </div>
            </Col>

            <Col lg="6" md="6" sm="12">
              <div className="about__page-content">
                <h2 className="section__title">
                 Zapewniamy najwyższy poziom bezpieczeństwa
                </h2>

                <p className="section__description">
                Naszą ofertę kierujemy do osób nie posiadających własnego motocykla / samochodu lub posiadających model, który niekoniecznie sprawdzi się w dalekiej turystyce. Zapraszamy również osoby, których pojazd uległ awarii czy wypadkowi. Oferujemy wynajem motocykli turystycznych, jak i sportowych samochodów. 
                </p>

                <p className="section__description">
                Skontaktuj się z nami w celu omówienia szczegółów dotyczących najmu pojazdu. Chętnie odpowiemy na wszystkie pytania i ustalimy jak najlepsze warunki współpracy.
                </p>

                <div className=" d-flex align-items-center gap-3 mt-4">
                  <span className="fs-4">
                    <i class="ri-phone-line"></i>
                  </span>

                  <div>
                    <h6 className="section__subtitle">Potrzebujesz pomocy? Zadzwoń do nas!</h6>
                    <h4>+48 600 265 091</h4>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

    </Helmet>
  );
};

export default About;
